<template>
  <path d="M18 3.975h-4a.996.996 0 0 0-.707.293L12 5.561l-1.293-1.293A.997.997 0 0 0 10 3.975H6a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3.586l1.707 1.707a.997.997 0 0 0 1.414 0l1.707-1.707H18a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1z"></path>
</template>
